<template>
  <header class="pts-header">
    <div class="pts-container">
      <img src="../assets/logo.jpg" alt="Logo" class="pts-logo" />
      <img src="../assets/fr.png" alt="Français" v-if="$polyglot.lang === 'en'" @click="changeLang('fr')" class="pts-flag" />
      <img src="../assets/en.png" alt="English" v-else @click="changeLang('en')" class="pts-flag" />
      <div class="pts-header__spacer"></div>
      <div class="pts-header__buttons">
        <a class="pts-header__button pts-header__contact" href="mailto:reservations.pts@gmail.com">{{ $t('contact', 'Nous contacter') }}</a>
        <a class="pts-header__button pts-header__booking" href="https://pts.limovtc.fr/demande/ajout/">{{ $t('book', 'Réserver') }}</a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  methods: {
    changeLang(lang) {
      this.$polyglot.setLang({ lang });
    }
  },
  mounted() {
    this.$polyglot.extendLocales({
      'fr': {
        'contact': 'Nous contacter',
        'book': 'Réserver'
      },
      'en': {
        'contact': 'Contact us',
        'book': 'Book'
      }
    })
  }
}
</script>

<style scoped>
.pts-header {
  width: calc(100% - 40px);
  height: 90px;
  padding: 0 20px;
  box-shadow: 0px 1px 10px #D5D5D5;
  margin: 0;
  position: fixed;
  z-index: 25;
  background: #FFFFFF;
}

.pts-header .pts-container {
  display: flex;
  align-items: center;
  height: 100%;
}

.pts-header .pts-logo {
  max-width: 110px;
  max-height: 70px;
}

.pts-header .pts-flag {
  margin-left: 10px;
  cursor: pointer;
}

.pts-header .pts-header__spacer {
  flex: 1;
}

.pts-header__spacer {
  text-align: center;
}

.pts-header__spacer img {
  max-height: 92px;
}

.pts-header .pts-header__buttons .pts-header__button {
  font: normal 16px Arial;
  border: 2px solid #222222;
  background-color: #FFFFFF;
  color: #222222;
  padding: 14px 28px;
  cursor: pointer;
  border-radius: 5px;
  margin-left: 15px;
  text-decoration: none;
}

@media (max-width:575px) {
  .pts-header .pts-header__buttons {
    display: flex;
    flex-direction: column;
  }

  .pts-header .pts-header__buttons .pts-header__button {
    padding: 5px 10px !important;
    font-size: 12px !important;
    text-align: center;
    margin: 3px 0px;
  }
}

@media (max-width: 770px) {
  .pts-header__spacer img {
    display: none;
  }
}

.pts-header .pts-header__buttons  .pts-header__booking {
  border-color: #8A0000;
  color: #8A0000;
}

.pts-header .pts-header__buttons .pts-header__booking:hover {
  color: white;
  background: #8A0000;
}

.pts-header .pts-header__buttons .pts-header__contact:hover {
  color: white;
  background: #222222;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue